import { Routes } from '@angular/router'

/**
 * The support screens are the main UI's own components, mounted here against the customer
 * environment list instead of a single one. They are lazy-loaded so that the environment ledger,
 * which is what Atlas is opened for, does not pay for Material and the table on first paint.
 */
export const routes: Routes = [
  {
    path: '',
    title: 'ATLAS.PAGES.ENVIRONMENTS',
    pathMatch: 'full',
    loadComponent: () => import('./overview/overview.component').then((module) => module.OverviewComponent),
  },
  {
    path: 'dashboard',
    title: 'ATLAS.PAGES.TODAY',
    loadComponent: () => import('@app/support/support-dashboard/support-dashboard.component').then((module) => module.SupportDashboardComponent),
  },
  {
    path: 'analytics',
    title: 'ATLAS.PAGES.ANALYTICS',
    loadComponent: () =>
      import('@app/support/support-analytics-dashboard/support-analytics-dashboard.component').then((module) => module.SupportAnalyticsDashboardComponent),
  },
  {
    path: 'conversations',
    title: 'ATLAS.PAGES.CONVERSATIONS',
    loadComponent: () =>
      import('@app/support/conversations/support-conversations-page/support-conversations-page.component').then(
        (module) => module.SupportConversationsPageComponent
      ),
  },
  {
    path: 'conversations/:environmentKey/:id',
    title: 'ATLAS.PAGES.CONVERSATION',
    loadComponent: () =>
      import('@app/support/conversations/support-conversation-page/support-conversation-page.component').then(
        (module) => module.SupportConversationPageComponent
      ),
  },
  {
    path: 'experiments',
    title: 'ATLAS.PAGES.EXPERIMENTS',
    loadComponent: () => import('./experiments/experiments.component').then((module) => module.ExperimentsComponent),
  },
  {
    path: 'experiments/new',
    title: 'ATLAS.PAGES.EXPERIMENT_NEW',
    loadComponent: () => import('./experiments/experiment-form.component').then((module) => module.ExperimentFormComponent),
  },
  // Below 'experiments/new', which this would otherwise match as a group key.
  {
    path: 'experiments/:groupKey',
    title: 'ATLAS.PAGES.EXPERIMENT',
    loadComponent: () => import('./experiments/experiment-detail.component').then((module) => module.ExperimentDetailComponent),
  },
  {
    path: 'models',
    title: 'ATLAS.PAGES.MODELS',
    loadComponent: () => import('./llm-defaults/llm-defaults.component').then((module) => module.LlmDefaultsComponent),
  },
  {
    path: 'utilities',
    title: 'ATLAS.PAGES.UTILITIES',
    loadComponent: () => import('./utilities/utilities.component').then((module) => module.UtilitiesComponent),
  },
  { path: '**', redirectTo: '' },
]
